import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "tag", "type"];
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'ul'
};
var List = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    cssModule = props.cssModule,
    Tag = props.tag,
    type = props.type,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, type ? "list-" + type : false), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: ref
  }));
});
List.defaultProps = defaultProps;
export default List;